// extracted by mini-css-extract-plugin
export default {"show_image":"Register_show_image__tHTXZ","col_left":"Register_col_left__K4kuI","col_right":"Register_col_right__cHaUR"};